/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/Animation-desktop"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Mayank Raj",
  title: "Hi, I'm Mayank",
  subTitle: emoji(
    `Hello! I'm Mayank, a Machine Learning Engineer . My background includes a Masters degree in Machine Learning, with a focus on Deep Learning and Natural Language Processing. I am a Software Engineer with 3 years of work experience in building microservices. I'm skilled at fixing scaling issues, implementing new features, and upgrading microservices to handle more traffic.`
  ),
  resumeLink:
    "https://drive.google.com/file/d/1GvmDWfvwSkP9e7dG8Hm6n-n51p8TqJn5/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/mayank3aj3769",
  linkedin: "https://www.linkedin.com/in/mayank-raj77",
  gmail: "mayank.raj3769@gmail.com",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: " Proficient in building microservices in node.js/typescript, Python and Go and applications of Deep Learning in Computer Vision and Natural Language Processing.",
  skills: [
    emoji(
      "⚡ Develop highly scalable event-driven microservices architecture."
    ),
    //emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Stevens Institute of Technology",
      logo: require("./assets/images/stevens logo.png"),
      subHeader: "Master of Science in Machine Learning ",
      duration: "September 2022 - December 2023",
      descBullets: ["GPA : 3.5/4" ,
        "Relevant Coursework: Artificial Intelligence, Deep Learning, Natural Language Processing,Computational Cognitive Science, Web Mining, Machine Learning - fundamentals and applications, Data Mining - II"],
    },
    {
      schoolName: "Manipal Institute of Technology",
      logo: require("./assets/images/manipal-logo.jpg"),
      subHeader: "Bachelor of Technology in Computer Science and Engineering",
      // duration: "Graduated in August 2020",
      descBullets: ["Graduation thesis got published in an international IEEE conference"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Microservices", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Go", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Python", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Machine Learning",
      progressPercentage: "90%"
    },
    {
      Stack: "Deep Learning",
      progressPercentage: "80%"
    },
    {
      Stack:"Natural Language Processing",
      progressPercentage:"85%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role:"Software Development Engineer-2",
      company: "Scimplify",
      companylogo: require("./assets/images/scimplify-squareLogo-1711094843715.webp"),
      date: "June 2024 – present",
      desc: "Joined as a member of the backend team",
      descBullets: [
        "Engineered scalable, fault-tolerant microservices in fastAPI for internal tools, addressing the product team's requirements and supporting over 200 manufacturing units  to improve customer experience",
        "Built a RAG based chatbot by fine-tuning Mistral-7B for an in-house platform using Langchain framework and Pinecone vectorDB to handle customer queries on specialty chemicals , their properties and manufacturers. Deployed on AWS SageMaker"  
      ]
    },
    {
      role: "Deep Learning Intern",
      company: "Micron",
      companylogo: require("./assets/images/micron-logo.jpg"),
      date: "May 2023 – July 2023",
      desc: "Silicon Systems AI Team",
      descBullets: [
        "Spearheaded optimization efforts that led to a 30% improvement in data retrieval speed for constructing abstract syntax trees and control and data flow graphs, enhancing Graph Convolutional Network data feed efficiency ",
        "Streamlined data preprocessing with an optimized ETL pipeline, achieving a 25% reduction in data preparation time for ML model training",
        "Leveraged Elastic search to optimize model training analytics, achieving a 20% faster parameter tuning process and optimization, granting immediate access to real-time insights for data-driven decision-making"
      ]
    },
    {
      role: "Associate Software Engineer",
      company: "Byjus",
      companylogo: require("./assets/images/byjus-logo.png"),
      date: "June 2021 – July 2022",
      desc:"Supply Chain Tech. team",
      descBullets:[
        "Developed and deployed machine learning models in Python to forecast inventory demand and optimize supply chain logistics, improving the accuracy of inventory management by 15% and reducing delivery times",
        "Integrated predictive models into microservices that handled over 2 million inventory requests, enabling real-time decision-making for product availability and shipment optimization",
        "Leveraged event-driven architecture using Redis for caching and Node.js, enhancing throughput by 35%, ensuring efficient processing of high-demand user requests",
        "Reduced the latency by 42% using an event driven architecture using Apache Kafka. Enhanced the UI using html/css and React.js to improve user experience for the platform or seamless project management "
      ]
    },
    {
      role: "Software Engineer",
      company: "kloudone",
      companylogo: require("./assets/images/kloudone-logo.png"),
      date: "Aug 2020 – Jan 2021",
      descBullets: ["Built and deployed microservices in Go using both REST API and gRPC for Accuknox, a container security platform, ensuring robust and scalable service communication.",
      " Enhanced the CI/CD pipeline using Jenkins and integrated automated testing and deployment processes"]
    }
  ]
};

const bigProjects = {
  title: "Projects",
  subtitle: "Projects covering various applications of Deep Learning and backend development",
  projects: [
      {
      image: require("./assets/images/pytorch-icon.png"),
      projectName: "LLM for sentiment analysis of global financial market conditions",
      descBullets:[ "Developed a sentiment analysis system for specific set of industries by utilizing the massive volume of online news stories.",
                    "Scraped the news articles using the newsdata.io API and stock market data using yahoo finance API.",
                    "Labelled the articles using VADER sentiment analyzer package.",
                    "Built a transformer based model consisting of pre-trained weights of BERT, RoBERTa and linear layers.", 
                    "Obtained the pearson correlation score of 0.87 between average stock price and sentiment score of a sector to validate the results."] ,
      footerLink: [{
          name: "Visit Website",
          url: "https://github.com/mayank3aj3769/Machine-Learning-Projects/blob/11548fc1881932d000cfa9ddf6e6635c7c999573/Sentiment%20Analysis%20of%20market%20conditions%20based%20on%20global%20news%20reports.ipynb"
        }]
    },{
      image: require("./assets/images/tensorflow-icon-2.png"),
      projectName:'Lexical Complexity Score Prediction Challenge ',
      descBullets:["Built a transformer-based deep learning model to accurately predict the lexical complexity scores of single words within English sentences on a dataset of over 500000 sentences.",
                   "Pre-processed the tokens by removing special characters, expanded the contractions, performed stemming and lemmatization on the tokens.",
                   "Model architecture used pre-trained BERT and RoBERTa models, obtained a cross-entropy loss of 0.0947"],
      footerLink:[{
        name:'Visit Website',
        url:'https://github.com/mayank3aj3769/Machine-Learning-Projects/tree/11548fc1881932d000cfa9ddf6e6635c7c999573/Lexical%20Complexity%20Score%20Predictor%20using%20a%20BERT%20Based%20model'
      }]
    },
    {
      image: require("./assets/images/threads-logo.png"),
      projectName:'Social Media Application Development: ThreadsAppClone ',
      descBullets:["Developed and deployed ThreadsAppClone, a responsive social media platform using TypeScript, Next.js, and Tailwind CSS, inspired by Meta's Threads.",
                  "Features includes user authentication, community engagement, and real-time updates.", 
                  "Implemented key features including posting threads, joining communities, role management, and responsive design to enhance user engagement and foster a vibrant community.",
                  "Managed the full project lifecycle, emphasizing agile practices and continuous deployment through Vercel for seamless production and scalability."
                  ],
      footerLink:[{
        name:'Visit Website',
        url:'https://thread-mraj.vercel.app/'
      }]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Deep Neural Network approach for navigation of autonomous vehicle",
      subtitle:
        " Designed a CNN-based Deep Learning model using over 200,000 real-world images and sensor data, integrating image compression and normalization techniques for GPU memory optimization. Published in IEEE, 6th International Conference for Convergence in Technology as first author. Citations – 4, h- index -1",
      image: require("./assets/images/IEEE-logo.png"),
      imageAlt: "IEEE Logo",
      footerLink: [
        {
          name: "Research Paper",
          url: "https://ieeexplore.ieee.org/abstract/document/9418189"
        },
        {
          name: "git repository",
          url: "https://github.com/mayank3aj3769/Autonomous-vehicle.git"
        }
      ]
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};



const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "mayank.raj3769@gmail.com",
  display: true
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  bigProjects,
  achievementSection,
  contactInfo,
  isHireable
};
